import { PlayerSocket } from "@ecommo/r2player";
import { OutterVideoPlayer } from "./OutterVideoPlayer";
import { useEffect, useRef } from "react";

function App() {
    const containerRef = useRef(null);
    const psRef = useRef(new PlayerSocket().Instance);

    useEffect(() => {
        if (containerRef.current) {
            psRef.current.maskEl = containerRef.current;
        }
    }, []);

    const props = window.ReactPlayerProps || {};
    // in case no props provided, use defaults for testing,
    if (props.photoRefCode === undefined) {
        props.serviceName = "internal"; //will be received from web-form
        props.photoRefCode = "46F9YUETGI";//will be received from web-form//GM3OF5K7WW
        props.tpl = 0; //will be received from web-form
        props.width = 757; //will be received from web-form
        props.height = 600; //will be received from web-form
        props.productsDescriptions = "aaa|bbb";//will be received from web-form
    }

    const refCodes = props.photoRefCode.split(",").map(x => x.trim()).filter(Boolean);
    //const productsDescriptions = props.productsDescriptions.split("|").map(x => x.trim()).filter(Boolean);
    const productsDescriptions =
            (props.productsDescriptions ?? "")
                .split("|")
                .map(x => x.trim())
                .filter(Boolean);
    const showLabels = refCodes.length > 1;
    const isSingle = refCodes.length === 1;
    var posterPrefix = "";
    var urlFormatPrefix = "";

    //localCache logic
    if (props.serviceName === "internal" || props.serviceName === "public") {
        posterPrefix = `https://segoma.com/ws/${props.serviceName}/GetPhoto/First/${props.tpl}`
        urlFormatPrefix = `https://segoma.com/ws/${props.serviceName}/GetBinaryPhoto/${props.tpl}`
    } else if (props.serviceName === "localCache") {
        posterPrefix = `https://qaserver-india.segoma.com/SGMLocalWebService.svc/GetPhoto/First/${props.tpl}`
        urlFormatPrefix = `https://qaserver-india.segoma.com/SGMLocalWebService.svc/GetBinaryPhoto/${props.tpl}`;
    }

    const players = refCodes.map((refCode, index) => {

      return {
        debugOn: false,
        hide360: false,
        hideZoom: true,
        autoplay: true,
        //hideFinger: true,
        width: props.width,
        height: props.height,
        canvasKey: refCode,
        productDescription: productsDescriptions[index] || "",
        isSecond: index > 0,
        isPaisPair: false,
        isTouch: false,
        displayType: "LargeDiamond",
        poster: `${posterPrefix}/${refCode}`,
        urlFormat: `${urlFormatPrefix}/${refCode}/{0}`
      };
    });

    return (
        <div
            ref={containerRef}
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: isSingle ? "center" : "flex-start",
                gap: "20px",
                flexWrap: isSingle ? "nowrap" : "wrap",
                width: "100%",
                marginTop: "1px"
            }}
        >
            {players.map((p, idx) => (
                <OutterVideoPlayer
                    key={idx}
                    r2pData={p}
                    playerSocket={!isSingle ? psRef.current : null}//null must be for single player to avoid issues in get binary files
                    showLabel={showLabels}
                />
            ))}
        </div>
    );
}

export default App;
